export const ACTIVE_USER_STATUS = 'Active';
export const PENDING_USER_STATUS = 'Pending';
export const SUSPENDED_USER_STATUS = 'Suspended';
export const INACTIVE_USER_STATUS = 'Inactive';
export const CONFIRMED_USER_STATUS = 'Confirmed';
